module.exports = __webpack_public_path__ + "static/nodejs-icon-c5bb051fce264aca024c2ff82949de26.png";